import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { StepDirective, StepperComponent, StepsDirective } from "@syncfusion/ej2-react-navigations";
import { WIZARD_STEPS } from "@/modules/client/loan-application/features/loan-origination/constants/wizard-steps";

/**
 * WizardStepper — Syncfusion StepperComponent for the loan application wizard.
 *
 * Renders a linear, read-only stepper showing progress across all wizard steps.
 * Controlled programmatically via ref (nextStep / previousStep).
 */
const WizardStepper = forwardRef(({ onChange }, ref) => {
  const handleStepChanged = args => {
    onChange?.(args);
  };

  return (
    <div
      className="pointer-events-none shrink-0 select-none px-6 py-4 sm:px-8"
      style={{ pointerEvents: "none" }}
      onClickCapture={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <StepperComponent
        ref={ref}
        stepChanged={handleStepChanged}
        linear
        readOnly
      >
        <StepsDirective>
          {WIZARD_STEPS.map((step, idx) => (
            <StepDirective key={step.label} text={`${idx + 1}`} label={step.label} />
          ))}
        </StepsDirective>
      </StepperComponent>
    </div>
  );
});

WizardStepper.displayName = "WizardStepper";

WizardStepper.propTypes = {
  onChange: PropTypes.func,
};

export default WizardStepper;

